import { optionsObjectToArray } from "@/common/utils/optionsObjectToArray";

export const reportFileTypes = {
  csv: 'CSV',
  xlsx: 'Excel (XLSX)',
  txt: 'Texto (TXT)',
};

export const reportFileTypesOptions = optionsObjectToArray(reportFileTypes);
